import React from "react";
import { SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";

export interface QueryBuilderLabelProps {
  label: string;
  typeographyVariant?: string;
  onClick?: () => void;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

export function QueryBuilderLabel(props: QueryBuilderLabelProps): JSX.Element {
  let hoverStyle = {};
  if (props.onClick) {
    hoverStyle = {
        cursor: 'pointer',
        textDecoration: 'underline'
    };
  }

  return (
    <Typography
      variant={(props.typeographyVariant || "h5") as any}
      sx={{
        m:0, p:0, pb:1, pt:1,
        fontWeight:'bolder',
        width: 'auto',
        position:'relative',
        '&:hover': {
          ...hoverStyle
        },
       ...props.sx
      }}>
      {props.label}
      {props.children}
    </Typography>
  );
}
